define([
	"dojo/_base/declare",
	"Sourcing/SupplierItemForm"
], function(declare,SupplierItemForm) {
	return declare(SupplierItemForm, {
		/** 
		 * @override
		 * @property {boolean} bTemplate -  indicate if it is from Template
		 */
		bTemplate: true,
		isFieldEditable: function(/*Field*/field) {
			// summary: This is to disable the SupplierItemDimensions field on supplier quote template form
			if(field.m_name == "SupplierItemDimensions"){
				return false;
			}
			return this.inherited(arguments);
		}
	});
});